import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";
import EnlargeIcon from "../assets/Enlarge-Icn.svg";
import EnlargeIconSmall from "../assets/Enlarge-Icn-Small.svg";

function OpenFullSizeImageButton({ onClick, buttonStyle }) {
  const padding = buttonStyle === "default" ? 20 : 10;

  return (
    <Button onClick={onClick} padding={padding}>
      {buttonStyle === "default" ? <EnlargeIcon /> : <EnlargeIconSmall />}
    </Button>
  );
}

export default OpenFullSizeImageButton;

OpenFullSizeImageButton.defaultProps = {
  buttonStyle: "default",
};

OpenFullSizeImageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonStyle: PropTypes.string.isRequired,
};
